import { render } from "./AddOnProducts.vue?vue&type=template&id=1c9bb2b9"
import script from "./AddOnProducts.vue?vue&type=script&lang=js"
export * from "./AddOnProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__